import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';

const AddAVirtualEventButton = buttonProps => {
  return (
    <ButtonV2 {...buttonProps} onClick={buttonProps.onClick}>
      Add A Virtual Event
    </ButtonV2>
  );
};

export default AddAVirtualEventButton;
